import React from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import NotificationImportantIcon from '@mui/icons-material/NotificationImportant';
import AddIcon from '@mui/icons-material/Add';
import ConfirmDialog from '../Modals/ConfirmDialog';
import AddBottleSlip from './AddBottleSlip';
import cloneDeep from 'lodash/cloneDeep';
import DeleteIcon from '@mui/icons-material/Delete';
import TokenService from '../../services/TokenService';
import { useSnackbar } from 'notistack';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import EventIcon from '@mui/icons-material/Event';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import ScheduleIcon from '@mui/icons-material/Schedule';
import dayjs from 'dayjs';
import {
    Card, CardContent, CardHeader,
    Button,
    Skeleton,
    Fab,
    Drawer,
    Slide,
    IconButton,
    Radio,
    RadioGroup,
    FormControlLabel,
    FormLabel,
    Fade
}
    from '@mui/material';

import styles from './Scheduler.module.css'; // Import css modules stylesheet as styles

function RecycleFirstCompletion(props) {
    const [confirmDialog, setConfirmDialog] = React.useState(null);
    const scheduleButtonRef = React.useRef(null);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [bottleSlips, setBottleSlips] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(false);

    React.useEffect(() => {
        loadData();
    }, []);

    function loadData() {
        setIsLoading(true);
        let postData = {
            orderGUID: props.PickupRequest.OrderGUID
        }
        TokenService.post(postData, 'Returner_GetBottleSlip')
            .then((response) => {
                setIsLoading(false);
                if (response.Result == "SUCCESS") {
                    let jsonData = JSON.parse(response.JsonData);
                    let bottleSlipsAdded = JSON.parse(jsonData.BottleSlips);
                    setBottleSlips(bottleSlipsAdded);
                }
               
            })
            .catch((response) => {
                setIsLoading(false);
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });
            });
    }

    function handleAddBottleSlipClicked() {
        setConfirmDialog({
            show: true,
            close: function () { setConfirmDialog(null) },
            title: 'Add Bottle Slip',
            content: <div>
                <AddBottleSlip onClose={handleAddBottleSlip} />
            </div>,
            data: ''
        });
        
    }

    function handleAddBottleSlip(didAccept, bottleSlip) {
        if (didAccept) {
            // add
            //setIsLoading(true);
            let temp = cloneDeep(bottleSlips);
            bottleSlip.isLoading = true;
            bottleSlip.loadGuid = uuidv4(); // used to find it after the post
            temp.push(bottleSlip);

            setBottleSlips(temp);

            //Returner_AddBottleSlip(string orderGUID, int quantity, string photoData, string loadingGuid)
            let postData = {
                orderGUID: props.PickupRequest.OrderGUID,
                quantity: bottleSlip.Quantity,
                photoData: bottleSlip.ImagePath,
                loadingGuid: bottleSlip.loadGuid
            }
            TokenService.post(postData, 'Returner_AddBottleSlip')
                .then((response) => {
                   
                    if (response.Result == "SUCCESS") {
                        let jsonData = JSON.parse(response.JsonData);
                        let pickupRequest = JSON.parse(jsonData.PickupRequest);
                        if (props.OnPickupRequestChanged !== undefined) {
                            props.OnPickupRequestChanged(pickupRequest);
                        }
                        let bottleSlipAdded = JSON.parse(jsonData.BottleSlip);
                        let loadingGuid = jsonData.LoadingGuid;

                        let itemFound = false;
                        let temp = cloneDeep(bottleSlips);

                        for (let i = 0; i < temp.length; i++) {
                            if (temp[i].loadingGuid !== undefined) {
                                if (temp[i].loadingGuid === loadingGuid) {
                                    itemFound = true;
                                    temp.splice(i, 1, bottleSlipAdded);
                                }
                            }
                        }

                        if (!itemFound ) {
                            temp.push(bottleSlipAdded);
                        }
                        setBottleSlips(temp);
                    }
                })
                .catch((response) => {
                    enqueueSnackbar('Oops, something went wrong', {
                        variant: 'error',
                    });
                });

        }
        setConfirmDialog(null);
    }

    function uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    function confirmRemoveBottleSlip(bottleSlip) {
        setConfirmDialog({
            show: true,
            close: confirmRemoveBottleSlipClosed,
            title: 'Remove Bottle Slip',
            cancelText:'Cancel',
            acceptText:'Remove',
            content: <div style={{display:'flex', justifyContent:'center', flexDirection:'column'} }>
                <div>Are you sure you want to remove this bottle slip?</div>
                <div style={{marginTop:'20px', marginBottom:'20px'} }>Quantity: {bottleSlip.Quantity}</div>
                <div>
                    <img style={{ maxWidth: '200px', maxHeight: '200px' }}
                        src={bottleSlip.ImagePath}
                    />
                </div>
            </div>,
            data: bottleSlip
        });
    }

    function confirmRemoveBottleSlipClosed(didAccept, bottleSlip) {
        if (didAccept) {

            let temp = cloneDeep(bottleSlips);

            for (let i = 0; i < temp.length; i++) {
                if (temp[i].BottleSlipId == bottleSlip.BottleSlipId) {
                    temp.splice(i, 1);
                    break;
                }
            }
            setBottleSlips(temp);

            let postData = {
                orderGUID: props.PickupRequest.OrderGUID,
                bottleSlipId: bottleSlip.BottleSlipId
            }
            TokenService.post(postData, 'Returner_DeleteBottleSlip')
                .then((response) => {
                    if (response.Result == "SUCCESS") {
                        let jsonData = JSON.parse(response.JsonData);
                        let pickupRequest = JSON.parse(jsonData.PickupRequest);
                        if (props.OnPickupRequestChanged !== undefined) {
                            props.OnPickupRequestChanged(pickupRequest);
                        }
                    }

                })
                .catch((response) => {
                    enqueueSnackbar('Oops, something went wrong', {
                        variant: 'error',
                    });
                });
        }
        setConfirmDialog(null);
    }

    function buildSkeleton() {
        return <div>
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'60%'} />
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'60%'} />
            <Skeleton variant="rectangular" sx={{ marginRight: 'auto', marginLeft: 'auto' }} height={'3px'} width={'90%'} />
          
        </div>
    }

    function buildTotals() {
        if (bottleSlips.length > 0) {
            let totalQuantity = 0;
            for (let i = 0; i < bottleSlips.length; i++) {
                totalQuantity += parseInt(bottleSlips[i].Quantity);
            }

            return <Card style={{ marginTop: '25px', marginBottom:'25px', maxWidth: '500px', marginLeft: 'auto', marginRight: 'auto', backgroundColor:'var(--sipzee-green-3)' }}>
                <CardContent>
                   
                  
                    <div style={{ display: 'flex', justifyContent: 'center', fontWeight: 'bold', fontSize: '18pt' }}>
                        Bottle Slips: <span style={{marginLeft:'5px'} }>{bottleSlips.length}</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', fontWeight: 'bold', fontSize: '18pt' }}>
                        Total Quantity: <span style={{marginLeft:'5px'} }>{totalQuantity}</span>
                    </div>
                </CardContent>
            </Card>
        }
    }

    return (<div style={{ height: '90vh', width: '100%', display: 'flex', flexDirection: 'column', backgroundColor: '#f5f5f5' }}>
        <div className={styles.SlideDrawerHeader}>
            <span style={{ marginRight: 'auto', alignSelf: 'center' }}>&nbsp;</span>
            <span>Recycling Completed</span>
            <IconButton onClick={() => props.onClose(false)} style={{ marginLeft: 'auto' }}><ExpandMoreIcon /></IconButton>
        </div>
        <div style={{ maxHeight: '80vh', overflow: 'auto' }}>

            <Card style={{ margin: '5px', maxWidth: '500px', marginLeft: 'auto', marginRight: 'auto' }}>
              
                <CardContent >
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <NotificationImportantIcon sx={{ fontSize: 40, color: 'var(--sipzee-red)', alignSelf: 'center' }} />
                        <div style={{ alignSelf: 'center' }}>To complete the order, please upload pics of of the bottle slips.</div>
                    </div>
                </CardContent>
            </Card>

            {isLoading ?
                buildSkeleton()
                :
                <>
                    {bottleSlips.length < 2 ? null :
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '15px', marginBottom: '15px' }}>
                            <Button ref={scheduleButtonRef} variant='outlined' disabled={bottleSlips.length === 0} sx={{ backgroundColor: (bottleSlips.length === 0 ? 'var(--sipzee-gray-3)' : 'var(--sipzee-green)') }} onClick={(e) => props.onPayment()}>Purchase</Button>
                        </div>
                    }

                    {buildTotals()}

                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <Fab className='pulseButton-yellow' sx={{ backgroundColor: 'var(--sipzee-yellow)', fontSize: 40, marginBottom: '15px' }}
                            onClick={() => handleAddBottleSlipClicked()}
                            aria-label="add">
                            <AddIcon />
                        </Fab>
                    </div>

                   

                    <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                        {

                            bottleSlips.map((bottleSlip, index) => {
                                return <Card style={{ margin: '15px', maxWidth: '500px', minWidth: '300px', marginLeft: 'auto', marginRight: 'auto', opacity: bottleSlip.isLoading == undefined ? 1 : bottleSlip.isLoading ? .5 : 1 }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px' }}>
                                        <div style={{ width: '40px' }}></div>
                                        <div style={{ textAlign: 'center', marginTop: '20px' }}>Quantity: {bottleSlip.Quantity}</div>

                                        {bottleSlip.isLoading == undefined || bottleSlip.isLoading === false ?

                                            <Fab onClick={() => confirmRemoveBottleSlip(bottleSlip)}>
                                                <DeleteIcon  />
                                            </Fab>
                                            :
                                            <div style={{ width: '40px' }}></div>
                                        }
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'center', padding: '10px' }}>
                                        <img style={{ maxWidth: '200px', maxHeight: '200px' }}
                                            src={bottleSlip.ImagePath}
                                        />
                                    </div>
                                </Card>
                            })
                        }
                    </div>

                    {bottleSlips.length < 2 ? null :
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Fab className='pulseButton-yellow' sx={{ backgroundColor: 'var(--sipzee-yellow)', fontSize: 40, marginBottom: '15px' }}
                                onClick={() => handleAddBottleSlipClicked()}
                                aria-label="add">
                                <AddIcon />
                            </Fab>
                        </div>
                    }

                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '15px' }}>
                        <Button ref={scheduleButtonRef} variant='outlined' disabled={bottleSlips.length === 0} sx={{ backgroundColor: (bottleSlips.length === 0 ? 'var(--sipzee-gray-3)' : 'var(--sipzee-green)') }} onClick={(e) => props.onPayment()}>Purchase</Button>
                    </div>
                </>
                }

            

        </div>

        {
            confirmDialog !== null ?
                <ConfirmDialog Close={confirmDialog.close} Title={confirmDialog.title} Content={confirmDialog.content} CancelText={confirmDialog.cancelText} AcceptText={confirmDialog.acceptText} Data={confirmDialog.data} />
                : null
        }
    </div>)
}

export default RecycleFirstCompletion;